import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'shared/store/store'
import { fetchEmailConfigurationRequest } from 'shared/store/emailSettings/configuration'
import { getActiveClient } from 'shared/store/clients/selectors'
import { fetchEmailSignatureRequest } from 'shared/store/emailSettings/signature'
import useRolesAccess from './useRolesAccess'

const useInitEmailSettings = () => {
  const dispatch = useAppDispatch()
  const activeClient = useAppSelector(getActiveClient)
  const { hasOnlyAdvisorRole } = useRolesAccess()

  useEffect(() => {
    if (!activeClient?.id) return
    if (hasOnlyAdvisorRole) return

    dispatch(fetchEmailConfigurationRequest())
    dispatch(fetchEmailSignatureRequest())
  }, [activeClient?.id, dispatch, hasOnlyAdvisorRole])
}

export default useInitEmailSettings
